var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticStyle:{"height":"calc(100vh - 92px)"}},[_c('tabs',{staticClass:"border-b-gris",attrs:{"tabs":_vm.rutas}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }